import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home, About, Blog, Projects, Contact, BlogPost } from './pages';
import './App.css';

function App() {
  return (
    <div className="App">
      <a className="skip-link" href="#page-content">Skip to content</a>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} /> {/* Dynamic Route */}
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
